import { FormlyFieldConfig } from '@ngx-formly/core';

export const fileInputForm: FormlyFieldConfig[] = [
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        wrappers: ['row'],
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            key: 'props.accept',
            type: 'input',
            props: {
              translate: true,
              label: 'formGenerator.uiElement.fileAcceptProp.label',
              placeholder: 'formGenerator.uiElement.fileAcceptProp.placeholder',
            },
          },
        ],
      },
      {
        wrappers: ['row'],
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            key: 'props.maxFileSize',
            type: 'input',
            props: {
              translate: true,
              label: 'formGenerator.uiElement.fileMaxFileSizeProp.label',
            },
          },
        ],
      },
    ],
  },
];
